"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDiastereotopicAtomIDsAndH = void 0;
const getDiastereotopicAtomIDs_1 = require("./getDiastereotopicAtomIDs");
/**
 *
 * @param {import('openchemlib').Molecule} molecule
 */
function getDiastereotopicAtomIDsAndH(molecule) {
    const OCL = molecule.getOCL();
    molecule = molecule.getCompactCopy();
    molecule.addImplicitHydrogens();
    molecule.ensureHelperArrays(OCL.Molecule.cHelperNeighbours);
    const diaIDs = (0, getDiastereotopicAtomIDs_1.getDiastereotopicAtomIDs)(molecule);
    const newDiaIDs = [];
    for (let i = 0; i < diaIDs.length; i++) {
        const diaID = diaIDs[i];
        const newDiaID = {
            oclID: diaID,
            hydrogenOCLIDs: [],
            nbHydrogens: 0,
        };
        if (molecule.getAtomicNo(i) === 1) {
            const atom = molecule.getConnAtom(i, 0);
            newDiaID.heavyAtom = diaIDs[atom];
        }
        for (let j = 0; j < molecule.getAllConnAtoms(i); j++) {
            const atom = molecule.getConnAtom(i, j);
            if (molecule.getAtomicNo(atom) === 1) {
                newDiaID.nbHydrogens++;
                if (!newDiaID.hydrogenOCLIDs.includes(diaIDs[atom])) {
                    newDiaID.hydrogenOCLIDs.push(diaIDs[atom]);
                }
            }
        }
        newDiaIDs.push(newDiaID);
    }
    return newDiaIDs;
}
exports.getDiastereotopicAtomIDsAndH = getDiastereotopicAtomIDsAndH;
//# sourceMappingURL=getDiastereotopicAtomIDsAndH.js.map